import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {ProductImage} from '@modules/page/components/product/components/product-image/product-images.component';
import {
  Orbitvu360Component
} from '@modules/page/components/product/components/product-image/orbitvu-360/orbitvu-360.component';

@Component({
  selector: 'app-product-image-modal',
  templateUrl: './product-image-modal.component.html',
  styleUrls: ['./product-image-modal.component.scss'],
  imports: [NgOptimizedImage, ModalContainerComponent, Orbitvu360Component]
})
export class ProductImageModalComponent {

  public product: any;

  public image: ProductImage;

}
